import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardMedia
} from '@mui/material';

const About: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom align="center">
        Hakkımızda
      </Typography>
      
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" gutterBottom>
          Rölyef Boyama Setleri
        </Typography>
        <Typography variant="body1" paragraph>
          Türkiye'nin önde gelen boya seti satıcısıyız. 10 yılı aşkın deneyimimizle kaliteli ürünler ve hızlı hizmet anlayışımızla hizmetinizdeyiz.
        </Typography>
        <Typography variant="body1" paragraph>
          Misyonumuz; çocuklara ve ailelere kaliteli, güvenli ve eğlenceli boya setleri sunarak yaratıcılıklarını geliştirmelerine yardımcı olmaktır.
        </Typography>
      </Box>
      
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" gutterBottom>
          Vizyonumuz
        </Typography>
        <Typography variant="body1" paragraph>
          Türkiye genelinde yaratıcılık ve eğlenceyi bir araya getiren en güvenilir boya seti markası olmak.
        </Typography>
      </Box>
      
      <Box sx={{ my: 4 }}>
        <Typography variant="h5" gutterBottom>
          Neden Bizi Tercih Etmelisiniz?
        </Typography>
        <Typography variant="body1" paragraph>
          • Kaliteli ve güvenli ürünler<br />
          • Hızlı kargo<br />
          • Uygun fiyatlar<br />
          • 7/24 müşteri hizmetleri<br />
          • Kullanıcı dostu alışveriş deneyimi
        </Typography>
      </Box>
    </Container>
  );
};

export default About;